// src/private/CardDetailPopup.jsx
import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box, Chip } from '@mui/material';
import theme from '../theme';
import { useT } from '../i18n/LanguageContext';

export default function CardDetailPopup({ card, onClose }) {
  const display = theme.home?.display || 'Georgia, serif';
  const t = useT();
  return (
    <Dialog open={!!card} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        {card && (
          <Box>
            {card.image && (
              <Box
                component="img"
                src={card.image}
                alt={card.label}
                sx={{ width: '100%', borderRadius: 2, mb: 2, display: 'block' }}
              />
            )}
            {card.group && (
              <Chip
                label={card.group}
                size="small"
                sx={{
                  mb: 1, fontWeight: 700, color: theme.home.cyanText,
                  background: '#F8F3EA',
                }}
              />
            )}
            <Typography sx={{ fontFamily: display, fontWeight: 700, fontSize: '1.2rem', mb: 1 }}>
              {card.label}
            </Typography>
            <Typography sx={{ fontSize: '0.95rem', lineHeight: 1.5 }}>
              {card.descrizioneBreve}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('canvas.cardDetail.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
